import service from '@/utils/request';

// @Tags partner
// @Summary 获取事件列表
// @Security ApiKeyAuth
// @Produce  application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"返回成功"}"
// @Router /reason/reasonList [post]
export var reasonList = function reasonList(data) {
  return service({
    url: "/xcpGameData/reason/reasonList",
    method: 'post',
    data: data
  });
};

//伙伴列表下拉框
export var reasonListAll = function reasonListAll(data) {
  return service({
    url: "/xcpGameData/reason/reasonListAll",
    method: 'post',
    data: data
  });
};